import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { DelayFailureAdminComponent } from './delay-failure-admin.component';

const routes: Routes = [
  { path: '', component: DelayFailureAdminComponent, data: { title: 'Delay Failure Admin' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DelayFailureAdminComponentRoutingModule {}

@NgModule({
  imports: [
    DelayFailureAdminComponentRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [DelayFailureAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DelayFailureAdminModule {}
